import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import PresentationViewer from "@/components/PresentationViewer";

export default function AdminPreviewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await api.get(`/presentations/${id}`);
        if (mounted) setData(res.data);
      } catch (e) {
        toast.error(apiError(e, "Could not open preview"));
        navigate(`/admin/presentations/${id}`);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [id, navigate]);

  if (!data) {
    return (
      <div className="fixed inset-0 bg-black flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-white/60" />
      </div>
    );
  }

  return (
    <PresentationViewer
      slides={data.slides || []}
      title={data.title}
      initialIndex={0}
      showClose
      showBrand
      onClose={() => navigate(`/admin/presentations/${id}`)}
    />
  );
}
